<script>
import FAQ from "../FAQ";
import support from "@/utils/support";

export default {
  props: {
    boleto: {
      type: [Object, Boolean],
      required: true
    }
  },

  components: {
    FAQ
  },

  data() {
    return {
      copied: false
    };
  },

  methods: {
    copyToClipBoard() {
      const el = document.createElement("textarea");
      el.value = document.getElementById("line_code").innerHTML;
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
      this.changeButtonCopy();
    },

    changeButtonCopy() {
      this.copied = true;
      setTimeout(() => (this.copied = false), 1000);
    },

    openSupport() {
      support.sendProofOfPayment();
    }
  }
};
</script>

<template>
  <section v-if="boleto.funding_instrument">
    <a href="https://www.donamaid.com/termos-de-uso" target="_blank" class="accept">
      Ao finalizar a compra, você concorda com os nossos termos de uso
      <span>
        <img src="/static/url.svg" class="rel-icon" />
      </span>
    </a>

    <div class="payment-title mt-10">seu boleto está pronto!</div>

    <div class="boleto-info">
      Agora você pode realizar o pagamento com linha digitável ou imprimi-lo.
      <b
        class="mt-5"
        id="line_code"
      >{{boleto.funding_instrument.line_code}}</b>

      <button
        @click="copyToClipBoard"
        class="btn btn-small pl-5 pr-5 ml-10 btn-copy mt-10"
        :class="{'bg-purple-outline': !copied, 'bg-green': copied}"
      >
        <img v-if="copied" class="mr-5" src="/static/icon-check.svg" height="10px" />
        <img v-else class="mr-5" src="/static/icon-copy.svg" height="10px" />
        <span v-if="copied">copiado!</span>
        <span v-else>copiar</span>
      </button>
    </div>

    <a :href="boleto.funding_instrument.url_print" target="_blank" rel="noopener noreferrer">
      <button class="boleto-download mt-20 mb-10">
        Baixar boleto
        <span>
          <img src="/static/download.svg" class="rel-icon" />
        </span>
      </button>
    </a>

    <p>
      Você contratou uma limpeza com menos de 72 horas de antecedência e selecionou boleto como forma de pagamento. Para confirmar a sua limpeza,
      <b class="pointer"  @click="openSupport">clique aqui</b> e envie o comprovante de pagamento com até 48 horas úteis antes da limpeza.
    </p>

    <faq />
  </section>
</template>

<style scoped>
.btn-checking {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

section {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.rel-icon {
  height: 13px;
  width: 13px;
}

.border-bottom {
  border-bottom: 1px solid #ddd;
}

.payment-title {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 10px 0;
  text-transform: uppercase;
  font-size: 22px;
  font-weight: 700;
}

.payment-title::after {
  content: "";
  text-align: center;
  display: block;
  width: 200px;
  margin-top: 10px;
  border-bottom: 1px solid var(--pink);
}

.accept {
  color: #333;
  font-size: 13px;
  font-weight: 300;
  line-height: 16px;
  margin: 10px 5px 0;
  padding: 3px 7px;
  font-style: italic;
  text-align: center;
}

.normal {
  font-style: normal;
}

.boleto-info {
  font-size: 16px;
  font-family: "Roboto";
  color: #333;
  font-weight: 300;
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.boleto-info b {
  font-weight: 700;
}

.boleto-info p a {
  color: var(--pink) !important;
}

.boleto-download {
  width: 240px;
  height: 50px;
  padding: 15px 0;
  text-align: center;
  border: 1px solid var(--pink);
  border-radius: 4px;
  background-color: #fff;
  font-size: 16px;
  text-transform: uppercase;
  color: var(--pink);
  font-weight: 500;
  cursor: pointer;
}

.btn-copy {
  transition: 0s;
}

@media (max-width: 442px) {
  .payment-title {
    font-size: 18px;
    padding-top: 0;
  }

  .boleto-info {
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/_Shared/Checkout/Payment/Boleto.vue